module.exports = __webpack_public_path__ + "img/change-details.a2bd10f1.png";